import * as React from 'react';
import { useState } from 'react';
import i18n from 'i18next';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

const AddsDataToTheMultTable = ({ data, type }) => {
    const stat = data.stat;
    let processedStatData = {};
    for (let item in stat) {
        if (!item.includes(type)) continue;
        const number = item.split(type)[1];

        processedStatData[number] = !processedStatData[number]
            ? { [item]: stat[item] }
            : { ...processedStatData[number], [item]: stat[item] };
    }
    // return <div>123</div>;
    return (
        <Box style={{ padding: '25px 0' }}>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            {['', 0, ...Object.keys(processedStatData)].map((el, index) => (
                                <TableCell
                                    key={index}
                                    align="right"
                                    variant="head"
                                    style={{
                                        fontWeight: 600,
                                    }}
                                >
                                    {el}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((row, index) => (
                            <TableRow key={index}>
                                <TableCell component="th" scope="row">
                                    {row}
                                </TableCell>
                                {Object.values(processedStatData[row]).map((el, i) => {
                                    return (
                                        <TableCell key={i} align="right">
                                            {!el ? (
                                                '-'
                                            ) : (
                                                <Tooltip placement="top" title={`${i}${type}${row}: ${el}`}>
                                                    <span>{el}</span>
                                                </Tooltip>
                                            )}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default AddsDataToTheMultTable;
